import { verificarPendenciaService } from "../../shared/services/verificarPendenciaService";

export default {
  async verificarPendenciaCampanha(
    { state, dispatch, rootState },
    options = {}
  ) {
    const { force = false } = options;

    if (state.verificado && !force) {
      return Boolean(state.temPendencia);
    }

    const cdCooperado = rootState.me?.cd_pessoa;

    if (!cdCooperado) {
      dispatch("clearCampanhaPendencia");
      return false;
    }

    try {
      const resultadoPendencia = await verificarPendenciaService.verificar(
        cdCooperado
      );

      dispatch("setCampanhaPendencia", resultadoPendencia);

      return Boolean(
        resultadoPendencia?.data?.temPendencia ??
          resultadoPendencia?.data?.tem_pendencia ??
          resultadoPendencia?.hasPendencia
      );
    } catch (error) {
      dispatch("clearCampanhaPendencia");
      return false;
    }
  },

  setCampanhaPendencia({ commit }, apiResponse) {
    const data = apiResponse?.data || apiResponse || {};
    const campanha = data.campanha || null;

    const temPendencia = Boolean(
      data.temPendencia ?? data.tem_pendencia ?? apiResponse?.hasPendencia
    );

    commit("SET_CAMPANHA_PENDENCIA", {
      temPendencia,
      campanha: campanha
        ? {
            tipoPendencia:
              campanha.tipoPendencia || campanha.tipo_pendencia || null,
            pendencia: campanha.pendencia || data.cdProced || null,
            mensagem: campanha.mensagem || "",
            detalhesCampanha:
              campanha.detalhes || campanha.detalhesCampanha || []
          }
        : null
    });
  },

  clearCampanhaPendencia({ commit }) {
    commit("CLEAR_CAMPANHA_PENDENCIA");
  }
};
